export const METERS_TO_MILES = 1609.344;
export const METERS_TO_KILOMETERS = 1000;

// returns miles or km based on isMetric
// target is the target distance in meters rounded to 1 decimal place
export const targetMetersToUnit = (target: number, isMetric: boolean) => {
  const divisor = isMetric ? METERS_TO_KILOMETERS : METERS_TO_MILES;
  return !target ? 0 : Math.round((target / divisor) * 10) / 10;
};

// returns miles or km based on isMetric
// totalDistanceRaw is the total distance in meters rounded down to one decimal place
export const distanceMetersToUnit = (
  totalDistanceMeters: number,
  isMetric: boolean,
) => {
  const distance =
    totalDistanceMeters / (isMetric ? METERS_TO_KILOMETERS : METERS_TO_MILES);
  if (distance < 100) return Math.floor(distance * 10) / 10;
  return Math.floor(distance);
};

// convert distance from chosen unit to meters
export const distanceFromUnitToMeters = (value: number, isMetric: boolean) => {
  const distanceInMeters = Math.round(
    isMetric ? value * METERS_TO_KILOMETERS : value * METERS_TO_MILES,
  );
  // round to 1 decimal place
  const distanceInMetersRounded = Math.round(distanceInMeters * 10) / 10;
  return distanceInMetersRounded;
};
